module.exports = __webpack_public_path__ + "img/DealerIcons-Facebook-On.05e60e8.jpg";